import { Component, EventEmitter, Input, Output } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';

import { NoteService } from '../../../../shared/services/note.service';
import { messageService } from 'app/shared/services/messages/message.module';
import { INote } from 'app/shared/interfaces/entity';

@Component({
    selector   : 'note-detail-item',
    templateUrl: './note-detail-item.component.html',
    styleUrls  : ['./note-detail-item.component.scss'],
    animations : fuseAnimations,
})
export class NoteDetailItemComponent
{
    @Input() height = '100%;';
    @Input() note: INote;
    @Input() showActions = true;
    @Input() readOnly = false;

    @Output() onPrint: EventEmitter<any> = new EventEmitter();

    constructor(private noteService: NoteService){}

    toggleStar(event)
    {
        event.stopPropagation();
        this.note.note.toggleStar();
        this.noteService.saveNote(this.note, undefined, undefined, 'Note Saved');
    }

    toggleImportant(event)
    {
        event.stopPropagation();
        this.note.note.toggleImportant();
        this.noteService.saveNote(this.note, undefined, undefined, 'Note Saved');
    }

    toggleSensitive(event)
    {
        event.stopPropagation();
        this.note.note.toggleSensitive();
        this.noteService.saveNote(this.note, undefined, undefined, 'Note Saved');
    }

    notifyCopied($event){
        messageService.success('Note copied to clipboard');
    }

    print($event){
        this.onPrint.emit($event);
    }
    
}
